export const LTI_MODE_STORAGE_KEY = "lti_session";

export type SearchParamsLike = {
	get: (key: string) => string | null;
};

export function is_lti_launch(search_params: SearchParamsLike): boolean {
	return search_params.get("lti_launch") === "true";
}

function get__session_storage(): Storage | null {
	if (typeof window === "undefined") return null;
	try {
		return window.sessionStorage;
	} catch {
		return null;
	}
}

export function set__lti_mode_flag(): void {
	if (typeof window === "undefined") return;
	try {
		// Use sessionStorage so LTI UI mode does not "stick" across normal browsing sessions.
		get__session_storage()?.setItem(LTI_MODE_STORAGE_KEY, "true");
	} catch {
		// ignore
	}
}

export function clear_lti_mode_flag(): void {
	if (typeof window === "undefined") return;
	try {
		get__session_storage()?.removeItem(LTI_MODE_STORAGE_KEY);
	} catch {
		// ignore
	}
}

export function is_lti_mode(search_params: SearchParamsLike): boolean {
	if (typeof window === "undefined") return false;

	const from_session_storage = (() => {
		try {
			return get__session_storage()?.getItem(LTI_MODE_STORAGE_KEY) === "true";
		} catch {
			return false;
		}
	})();

	return from_session_storage || is_lti_launch(search_params);
}

export function ensure_lti_mode_flag(search_params: SearchParamsLike): void {
	if (is_lti_launch(search_params)) set__lti_mode_flag();
}

/**
 * Gets search params from window.location.search (always available on client)
 * Useful for first-render detection before useSearchParams() is ready
 */
export function get__window_search_params(): SearchParamsLike | null {
	if (typeof window === "undefined") return null;
	return new URLSearchParams(window.location.search);
}

export function get__lti_error_url(locale: string | null | undefined, message: string): string {
	const locale_prefix = (locale === "en-gb" || locale === "en-us") ? `/${locale}` : "";
	return `${locale_prefix}/lti-error?message=${encodeURIComponent(message)}`;
}


